import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[disableControl]',
  standalone: true,
})
export class DisableControlDirective {
  constructor(private readonly ngControl: NgControl) {}

  private readonly disabled$$ = new BehaviorSubject(false);
  readonly disabled$ = this.disabled$$.asObservable();

  @Input() set disableControl(disabled: boolean) {
    const control = this.ngControl.control;

    const action = disabled ? 'disable' : 'enable';
    control?.[action]();

    if (control) {
      this.disabled$$.next(control.disabled);
    }
  }
}
